<template>
    <div class="page-con other-class-xxw0410" style="background-color: #fbfbfbe6;">
        <div class="container search-containerx">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="layui-tab layui-tab-brief"
                style="width: 100%;">
                <el-tab-pane label="专业课" name="first">

                    <div id="search_contx" class="search-contx md2018040802-xxw clearfix">
                        <div  class="more_left" style="margin-left: 10px;">
                            <v-tree ref="vtree" :data="data" @select="select" show-line></v-tree>
                        </div>
                        <div class="more_right" style="height: 560px;overflow: scroll;">
                            <ul class="md-bd clearfix md-2018040201-lty">
                                <li v-for="(item,index) in majorCourseList" :key="index"
                                    class="pic-box pic-box-g pull-left live" @click="courseDetail(item)">
                                    <a></a>
                                    <div class="hd-pic" style="position: relative;"><a>
                                            <div class="course_img" style="position: absolute;box-sizing: border-box;">
                                                {{item.courseName}}</div><img
                                                src="../../../static/img/courseBack.jpg"><i class="state"></i>
                                        </a>
                                    </div>
                                    <div class="bd-word bgcolor-fff">
                                        <h4 class="bd-tit"><a style="color: black;">{{item.courseName}}</a></h4>
                                        <div class="clearfix"><span
                                                class="sign-num pull-left color-888">{{item.coursePeriod}}学时</span><span
                                                class="sign-num pull-right color-888">{{item.courseStudyNum}}人报名</span>
                                        </div>
                                        <div class="clearfix" style="margin-top: 9px;">
                                            <!-- <span
                                                class="price pull-left">￥{{item.coursePrice}}</span> -->
                                            <!-- <a v-if="item.shoppingCartState ==1" class="xuanze"
                                                @click="addShoppingCart(index,item)">加入购物车</a> -->
                                            <a v-if="item.coursePrice ==0" class="xuanze"
                                                @click="Signupimmediately(index,item)">立即报名</a>
                                            <!-- <a v-if="item.shoppingCartState ==2" style="background-color: red;"
                                                class="xuanze" @click="shiftOutShoppingCart(index,item)">移出购物车</a> -->
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <div v-if='marjorflag' class="text-center font-20" style="padding: 50px;padding-top:180px">
                                <img src="../../../static/img/empty.png"></div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="公共课" name="second">

                    <div id="search_contx" class="search-contx md2018040802-xxw clearfix">
                        <div class="more_right">
                            <ul class="md-bd clearfix md-2018040201-lty">
                                <li v-for="(item,index) in publicCourseList" :key="index"
                                    class="pic-box pic-box-g pull-left live">
                                    <a href="/el/cd?courseId=381" target="_blank"></a>
                                    <div class="hd-pic" style="position: relative;"><a>
                                            <div class="course_img" style="position: absolute;box-sizing: border-box;">
                                                {{item.courseName}}</div><img src="../../../static/img/courseBack.jpg"
                                                onerror="this.onerror=null;this.src='/img/courseBack.jpg'"><i
                                                class="state"></i>
                                        </a>
                                    </div>
                                    <div class="bd-word bgcolor-fff">
                                        <h4 class="bd-tit"><a href="/el/cd?courseId=381" class="color-333"
                                                target="_blank">{{item.courseName}}</a></h4>
                                        <div class="clearfix"><span
                                                class="sign-num pull-left color-888">{{item.coursePeriod}}学时</span><span
                                                class="sign-num pull-right color-888">{{item.courseStudyNum}}人报名</span>
                                        </div>
                                        <div class="clearfix" style="margin-top: 9px;"><span
                                                class="price pull-left">￥{{item.coursePrice}}</span><a
                                                href="javascript:;" data-courseid="381" data-classid="null"
                                                data-majorid="undefined" data-coursetype="2" data-courseperiod="27.6"
                                                class="xuanze">加入购物车</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <div v-if='publicflag' class="text-center font-20" style="padding: 50px;padding-top:180px">
                                <img src="../../../static/img/empty.png"></div>
                        </div>
                    </div>

                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- <div class="c-assignmentcollect c-assignmentcollect-new"
            :class="moveFlag?moveLeftRight==='left' ? 'animationLeftExpose':'animationRightExpose':''">
            <div class="c-assignmentcollect__header" @click="moveLeftOrRight">
                <span class="switch">
                    <img v-if="moveLeftRight != 'left'" src="../../../static/img/rightarrows.png"
                        style="position: absolute;left: 10px;top: 9px;width: 20px;height: 20px;">
                    <img v-if="moveLeftRight =='left'" src="../../../static/img/leftarrows.png"
                        style="position: absolute;left: 10px;top: 9px;width: 20px;height: 20px;">
                </span>
                <span>购物车</span>
            </div>
            <div class="c-assignmentcollect__below">
                <div class="title">
                    已选课时 <span>
                    </span>
                    <a id="yixuan" @click="selectCourseDetails()"> &nbsp;详情 </a>
                </div>
                <ul class="c-assignmentcollect__subject">
                    <li class="nodateli" style="display: none;">暂无课程！</li>
                    <li class="type-01" data-type="01">公共课：<span><span style="color: red;">{{publicSumPeriod}}</span>
                            课时</span><i class="type-del"></i>
                    </li>
                    <li class="type-03" data-type="03">专业课：<span><span style="color: red;">{{majorSumPeriod}}</span>
                            课时</span><i class="type-del"></i>
                    </li>
                    <li class="type-03" data-type="03">金&nbsp;&nbsp;&nbsp;额：<span><span style="color: red;">
                                {{sumPrice}}</span>
                            ￥</span><i class="type-del"></i></li>

                </ul>
                <div class="f-tac">
                    <a class="layui-btn layui-btn-sm layui-btn-radius manualPaper-btn " id="toBuy"
                        style="background-color: #49af4a;width: 44%;" @click="buyCourse()">购买</a>
                </div>
            </div>
        </div> -->
        <el-dialog title="已选课程" :visible.sync="dialogVisible" width="50%">

            <div id="ddBox" class="cont-1206">
                <div v-for="(item,index) in addShoppingCartCourseIdList" :key="index" class="md-2019120501-xxw type1">
                    <div class="md-hd"><span v-if="item.courseType ==2" class="color-333">课程类型：专业课</span>
                        <span v-if="item.courseType ==1" class="color-333">课程类型：公共课</span></div>
                    <div class="md-bd clearfix" style="display: flex;">
                        <div class="col-3-1206 clearfix md-19120602-xxw null" style="display: flex;">
                            <div class="d1 pull-left">
                                <div class="course_img1"
                                    style="font-size: 8px; position: absolute;box-sizing: border-box;">
                                    {{item.courseName}}</div>
                                <img src="../../../static/img/courseBack.jpg">
                                <i class="state"></i>
                            </div>
                            <div class="text-box pull-left">
                                <p class="p1 text-overflow font-16 color-333">{{item.courseName}}</p>
                                <p class="p3 color-333 font-18 ">￥<span class="coursePrice">{{item.coursePrice}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-3-1206 col2">课时：{{item.coursePeriod}}</div>
                        <div class="col-3-1206 col31" style="margin: auto;"><button class="btn1 js-zhifubtn delCourse"
                                data-courseid="368" data-courseperiod="6.2" data-coursetype="2" data-worktypeid="65"
                                style="margin-bottom: 0px;" @click="shiftOutShoppingCart(index,item)">删除</button><br>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import Vue from 'vue'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    // vue-beauty 树形组件 单独引入
    //import {tree} from 'vue-beauty' 
    //Vue.use(tree)

    //vue-beauty 多有组件全部引入
    import vuebeauty from 'vue-beauty'
    Vue.use(vuebeauty)

    export default {
        name: 'app',
        compoents: {
        },
        data() {
            return {
                dialogVisible: false,
                data: [],
                activeName: 'first',
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                courseType: 2,
                majorCourseList: [],
                publicCourseList: [],
                marjorflag: false,
                publicflag: false,
                moveLeftRight: '',
                moveFlag: false,
                addShoppingCartCourseIdList: [],
                majorSumPeriod: 0,
                publicSumPeriod: 0,
                sumPrice: 0
            }
        },
        created() {
            
          
            this.$parent.leftBeginAffirm(1);
            //console.log(this.$storage.get("declareUser").id)
            //加载工种
             this.loadData(this.$route.params.workTypeId);
            if (this.$route.params.workTypeId != 'undefined') {
                let parames = new URLSearchParams();
                parames.append('workTypeId', this.$route.params.workTypeId);
                this.loadCourse(parames);
            } else {
                //加载专业课程
                this.loadCourseData(2);
                //加载公共课程
                this.loadCourseData(1);
            }
        },
        mounted() {
            document.documentElement.scrollTop = 0;
          
            //this.$nextTick(() =>{
                      //  console.log(document.getElementsByClassName('ant-tree-node-selected'))
                        
                     // this.$nextTick(()=>{

                        //this.$refs.wechatBind.reloadWxLogin();
                      //  document.getElementsByClassName('ant-tree-node-selected')[0].scrollIntoView();
                     //   });

                      setTimeout(function(){
                        //document.getElementsByClassName('ant-tree-node-selected')[0].scrollIntoView();
                        document.documentElement.scrollTop = 0;
                      },2000)
                    
                //   })


         //   this.$refs.vtree.animate({scrollTop:this.$refs.vtree.offset().top}, 800);
        },
        methods: {
            courseDetail(item){
                this.$router.push({ path: '/courseBuyDetail/' + item.courseId +"/" +item.workTypeName  })
            },
            buyCourse() {

                if (this.addShoppingCartCourseIdList.length > 0) {

                    let courseIds = '';
                    this.addShoppingCartCourseIdList.forEach(ele => {
                        courseIds += ele.courseId + ','
                    })

                    let parames = new URLSearchParams();
                    parames.append('order_status', 1);
                    parames.append('order_amount', this.sumPrice);

                    parames.append('userId', this.$storage.get("declareUser").id);

                    parames.append('courseIds', courseIds);

                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/addOrderRecordCourse', parames).then(resp => {

                        if (resp.data.code === 1) {

                            const { href } = this.$router.resolve({
                                name: "coursePay",
                                params: {}
                            });
                            this.$storage.set('orderRecord', resp.data.orderRecord)
                            window.open(href, '_blank');

                            let _this = this;
                            this.$confirm('确认支付完毕?', '提示', {
                                cancelButtonText: '取消',
                                confirmButtonText: '确定',
                                type: 'warning'
                            }).then(() => {
                                //加载专业课程
                                this.loadCourseData(2);
                                //加载公共课程
                                this.loadCourseData(1);
                                //购物车清零
                                this.majorSumPeriod = 0
                                this.publicSumPeriod = 0
                                this.sumPrice = 0
                            }).catch(() => {
                                //加载专业课程
                                this.loadCourseData(2);
                                //加载公共课程
                                this.loadCourseData(1);
                                //购物车清零
                                this.majorSumPeriod = 0
                                this.publicSumPeriod = 0
                                this.sumPrice = 0
                            });

                        } else {
                            this.$message({
                                showClose: true,
                                message: '服务器繁忙，稍后重试！',
                                type: 'error'
                            });
                        }
                    }).catch(err => {
                        this.$message({
                            showClose: true,
                            message: '服务器繁忙，稍后重试！',
                            type: 'error'
                        });
                    })


                } else {
                    this.$message({
                        message: '暂无选择课程！',
                        offset: 250,
                        type: 'warning',
                        duration: 1500
                    });
                }
            },
            selectCourseDetails() {
                if (this.addShoppingCartCourseIdList.length > 0) {
                    this.dialogVisible = true;
                } else {
                    this.$message({
                        message: '暂无选择课程！',
                        offset: 250,
                        type: 'warning',
                        duration: 1500
                    });
                }
            },
            //立即报名
            Signupimmediately(index, item) {
                let parames = new URLSearchParams();

                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('trainState', 2);
                parames.append('workTypeId', item.workTypeId);
                this.$axios.post(this.serverUrl + '/tm/getTrainPower', parames).then(resp => {

                    if (resp.data.code === 1) {

                        this.$message({
                            message: '报名成功',
                            type: 'warning',
                            center: true,
                            offset: 300,
                            duration: 1500
                        });

                    } else {
                        this.$message({
                            message: '暂无权限！',
                            type: 'warning',
                            center: true,
                            offset: 300
                        });
                    }
                }).catch(err => {
                    console.log(err);
                })

            },
            //专业课加入购物车
            addShoppingCart(index, item) {
                this.majorCourseList[index].shoppingCartState = 2
                let course = {
                    courseId: 0,
                    courseType: 0,
                    courseName: '',
                    coursePeriod: 0,
                    coursePrice: 0
                }
                course.courseId = item.courseId
                course.courseType = item.courseType
                course.courseName = item.courseName
                course.coursePeriod = item.coursePeriod
                course.coursePrice = item.coursePrice


                this.addShoppingCartCourseIdList.push(course);

                this.majorSumPeriod = (this.majorSumPeriod * 10000 + item.coursePeriod * 10000) / 10000

                this.sumPrice = (this.sumPrice * 10000 + item.coursePrice * 10000) / 10000
                console.log(this.addShoppingCartCourseIdList)

            },
            //专业课移出购物车
            shiftOutShoppingCart(index, item) {

                this.majorCourseList.forEach(ele => {

                    if (ele.courseId === item.courseId) {
                        ele.shoppingCartState = 1
                    }

                })

                let index2 = 0;
                this.addShoppingCartCourseIdList.forEach(function (ele, index1) {
                    if (ele.courseId === item.courseId) {
                        index2 = index1;

                    }
                })
                this.addShoppingCartCourseIdList.splice(index2, 1);

                this.majorSumPeriod = (this.majorSumPeriod * 10000 - item.coursePeriod * 10000) / 10000


                this.sumPrice = (this.sumPrice * 10000 - item.coursePrice * 10000) / 10000


                console.log(this.addShoppingCartCourseIdList)
            },
            //客服左移右移
            moveLeftOrRight() {
                if (this.moveLeftRight === '') {
                    this.moveLeftRight = 'left';
                } else if (this.moveLeftRight === 'left') {
                    this.moveLeftRight = 'right';
                } else {
                    this.moveLeftRight = 'left';
                }
                this.moveFlag = true;//开启动画
            },
            select(data) {
                console.log(data[0])
                let parames = new URLSearchParams();

                if (data[0].children === undefined) {
                    parames.append('workTypeLevelState', data[0].id);
                    parames.append('workTypeId', data[0].fId);
                } else {
                    parames.append('workTypeId', data[0].id);
                }

                parames.append('courseType', this.courseType);

                this.loadCourse(parames);
            },
            loadCourse(parames) {
                //获取 当前等级下的上传资料 列表

                this.$axios.post(this.serverUrl + '/el/selectWorkTypeCourse', parames).then(resp => {
                    if (resp.data.code === '1') {

                        if (this.courseType === 2) {
                            resp.data.data.forEach(ele => {

                                let flag = true;
                                this.addShoppingCartCourseIdList.forEach(e => {

                                    if (ele.courseId === e) {
                                        flag = false;
                                    }

                                })

                                if (flag) {
                                    ele.shoppingCartState = 1
                                } else {
                                    ele.shoppingCartState = 2
                                }


                            })
                            this.majorCourseList = resp.data.data
                        } else {
                            resp.data.data.forEach(ele => {
                                ele.shoppingCartState = 1
                            })
                            this.publicCourseList = resp.data.data
                        }

                        if (resp.data.data.length <= 0) {
                            if (this.courseType === 2) {
                                this.marjorflag = true;
                            } else {
                                this.publicflag = true;
                            }

                        } else {

                            if (this.courseType === 2) {
                                this.marjorflag = false;
                            } else {
                                this.publicflag = false;
                            }

                        }

                    }
                  //  this.$nextTick(() =>{
                   //     this.$refs.vtree.scrollTop(0,800);
                     // })

                    
                   
                }).catch(err => {
                    console.log(err);
                })
            },
            handleClick(tab, event) {

            },
            loadCourseData(courseType) {
                //获取 当前等级下的上传资料 列表

                let parames = new URLSearchParams();

                parames.append('courseType', courseType);
                this.$axios.post(this.serverUrl + '/el/selectWorkTypeCourse', parames).then(resp => {
                    if (resp.data.code === '1') {

                        if (courseType === 2) {
                            resp.data.data.forEach(ele => {
                                ele.shoppingCartState = 1
                            })
                            this.majorCourseList = resp.data.data
                        } else {
                            resp.data.data.forEach(ele => {
                                ele.shoppingCartState = 1
                            })
                            this.publicCourseList = resp.data.data
                        }

                        if (resp.data.data.length <= 0) {
                            if (courseType === 2) {
                                this.marjorflag = true;
                            } else {
                                this.publicflag = true;
                            }

                        } else {

                            if (courseType === 2) {
                                this.marjorflag = false;
                            } else {
                                this.publicflag = false;
                            }

                        }

                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            //加载工种数据
            loadData(workTypeId) {
                let parames = new URLSearchParams();
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectWorkTypeLevel', parames).then(resp => {

                    if (resp.data.code === '1') {
                        let ArrayList1 = [];
                        resp.data.data.forEach(ele => {

                            let data = {
                                id: '',
                                title: '',
                                children: []
                            }

                            data.title = ele.title
                            data.id = ele.id;

                            if (workTypeId != undefined && workTypeId == ele.id) {
                                data.selected = true;
                            }

                            let ArrayList = [];
                            ele.children.forEach(ele => {

                                let data1 = {
                                    id: '',
                                    title: '',
                                    fId: ''
                                }

                                data1.id = ele.id
                                data1.title = ele.title

                                data1.fId = ele.fid
                                ArrayList.push(data1);
                            })

                            data.children = ArrayList;

                            ArrayList1.push(data);
                        })

                        this.data = ArrayList1
                    }
                }).catch(err => {
                    console.log(err);
                })


            },
        }

    }
</script>


<style scoped>

div /deep/ .md-2018040201-lty {
    margin: 0 0px 20px !important;
}
    .md-2019120501-xxw .d1 img {
        height: 100%;
        width: 100%;
    }

    .md-19120602-xxw .d1 {
        width: 82px !important;
        height: 51px !important;
        position: relative !important;
        -webkit-border-radius: 6px 6px !important;
        -moz-border-radius: 6px 6px !important;
        border-radius: 6px 6px !important;
        overflow: hidden !important;
    }

    .font-18 {
        font-size: 18px;
    }

    .p3 {
        color: green;
    }

    .md-19120602-xxw .text-box>p {
        margin-bottom: 8px;
    }

    .md-19120602-xxw .text-box {
        width: 140px !important;
        padding-left: 30px !important;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .md-2019120501-xxw .col31 button.btn1 {
        background: red;
        color: #fff;
        padding: 6px 16px;
        border-radius: 4px;
    }

    .md-2019120501-xxw .col2 {
        font-size: 24px !important;
        color: #909090 !important;
        line-height: 64px !important;
        text-align: center !important;
        border: 1px dashed #dcdcdc !important;
        border-top: none !important;
        border-bottom: none !important;
        width: 200px;
    }

    .color-333 {
        color: #333;
    }

    .cusfont-dingdan:before {
        content: "\e605";
    }

    .color-blue {
        color: #4b95ff;
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2019120501-xxw>.md-hd {
        border-bottom: 1px solid #ddd !important;
        line-height: 32px !important;
        margin-bottom: 12px !important;
    }

    .md-2019120501-xxw {
        padding: 5px 28px 11px !important;
        border-radius: 8px !important;
        overflow: hidden !important;
        box-shadow: 0 0 15px #eee !important;
        margin-bottom: 20px !important;
    }

    #ddBox {
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 80px;
        height: 558px;
        overflow-y: auto;
    }

    .animationLeftExpose {
        animation: moveLeftExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
    }

    .animationRightExpose {
        animation: moveRightExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    @keyframes moveLeftExpose {
        from {
            right: -160px;
        }

        to {
            right: 0px;
        }
    }

    @keyframes moveRightExpose {
        from {
            right: 0px;
        }

        to {
            right: -160px;
        }
    }

    .el-tree-node:focus>.el-tree-node__content {
        background-color: transparent !important;
    }

    .c-assignmentcollect__subject li {
        position: relative;
        font-size: 12px;
        line-height: 30px;
        cursor: pointer;
    }

    .c-assignmentcollect__subject .nodateli {
        text-align: center;
    }

    .c-assignmentcollect__subject {
        text-indent: 16px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .c-assignmentcollect-new.c-assignmentcollect .c-assignmentcollect__subject {
        height: 177px;
        margin-bottom: 15px;
    }

    .f-tac {
        text-align: center !important;
    }

    .c-assignmentcollect__subject li em {
        color: #f7785f;
    }

    .c-assignmentcollect-new.c-assignmentcollect .title {
        position: relative;
        height: 38px;
        line-height: 38px;
        background: #eee;
        padding-left: 0;
        text-indent: 16px;
    }

    .c-assignmentcollect__below {
        height: 276px;
    }

    .c-assignmentcollect-new .c-assignmentcollect__below {
        width: 160px;
        float: right;
    }

    .c-assignmentcollect .c-assignmentcollect__header i {
        display: inline-block;
        width: 25px;
        height: 25px;
        vertical-align: text-bottom;
    }

    /* .c-assignmentcollect-new .switch:after {
        position: absolute;
        left: 16px;
        top: 9px;
        display: inline-block;
        content: "";
        border: 10px solid transparent;
        border-left-color: #fd9007;
    } */

    .c-assignmentcollect-new .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 38px;
        margin-left: -10px;
        margin-top: -1px;
        cursor: pointer;
    }

    .c-assignmentcollect-new .c-assignmentcollect__header {
        cursor: pointer;
        float: left;
        height: 100%;
        line-height: inherit;
        width: 40px;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        font-weight: bold;
        border-radius: 3px 0 0 3px;
        background-color: #002856;
        color: #fff;
    }

    .c-assignmentcollect {
        position: fixed;
        right: -160px;
        top: 100px;
        width: 200px;
        background: #fff;
        box-shadow: -1px 1px 6px rgb(0 0 0 / 30%);
        z-index: 100;
        height: 275px;
        border-radius: 3px 0 0 3px;
        transition: width 0.4s ease-in-out;
        overflow: hidden;
    }


    .text-center {
        text-align: center;
    }

    div /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
        border-left: none;
        width: 50%;
        text-align: center;
    }

    div /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 1px solid #E4E7ED;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
    }

    div /deep/ .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
        padding-right: 20px;
        width: 50%;
        text-align: center;
    }

    div /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
        border-bottom-color: #FFF;
        width: 50%;
        text-align: center;
    }

    .page-header,
    .page-con,
    .page-body,
    .page-footer {
        min-width: 1200px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .layui-tab {
        text-align: left !important;
        margin-top: 20px;
    }

    .md2018040802-xxw {
        margin: 0 -10px;
    }

    .layui-tab-title {
        position: relative;
        left: 0;
        height: 40px;
        white-space: nowrap;
        font-size: 0;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        transition: all .2s;
        -webkit-transition: all .2s;
        width: 1200px;
        height: 50px;
        line-height: 50px;
        background: #f4f4f4;
        border-radius: 6px;
        margin-bottom: 31px;
        padding-left: 1px;
    }

    .layui-tab-brief>.layui-tab-title .layui-this1 {
        background: #ffffff;
        -webkit-box-shadow: 0px 0px 8px 0px rgb(0 0 0 / 15%);
        box-shadow: 0px 0px 8px 0px rgb(0 0 0 / 15%);
        border-radius: 10px 10px 0px 0px;
        border-bottom: 2px solid #ff4936;
        color: #ff4936;
        width: 599px;
    }

    .layui-tab-title li {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        min-width: 65px;
        padding: 0 15px;
        width: 600px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        overflow: hidden;
    }

    .layui-tab-content {
        padding: 10px;
    }

    .layui-show {
        display: block !important;
    }

    .more_left {
        width: 19%;
        height: auto;
        float: left;
        border: 3px solid #a4cbff;
        height: 560px;
        overflow-y: auto;
        border-radius: 7px;
        box-shadow: 0px 0px 3px #aacfff;
    }

    .layui-tree-entry {
        position: relative;
        padding: 3px 0;
        height: 32px !important;
        white-space: nowrap;
    }

    .layui-tree-entry {
        line-height: 25px;
    }

    .more_right {
        width: 79%;
        float: right;
    }

    .md2018040802-xxw .md-2018040201-lty {
        margin-bottom: 38px;
    }

    .md-2018040201-lty {
        margin: 0 -10px 20px;
    }

    .md-2018040201-lty .pic-box {
        position: relative !important;
        transition: all .1s ease !important;
        overflow: hidden !important;
        width: 212px !important;
        margin: 0 15px !important;
        border-radius: 5px !important;
    }

    .pull-left {
        float: left;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 125px;
        position: relative;
    }

    .course_img {
        position: absolute;
        top: 31%;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 19px;
        font-weight: 400;
        letter-spacing: 8px;
        padding: 0 18px;
    }

    .course_img1 {
        position: absolute;
        top: 15%;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 19px;
        font-weight: 400;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .md-2018040201-lty .pic-box .bd-word {
        padding: 15px;
        font-size: 12px;
    }

    .bgcolor-fff {
        background: #fff;
    }

    .md-2018040201-lty .pic-box .bd-word .bd-tit {
        font-size: 14px;
        line-height: 20px;
        height: 40px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        white-space: nowrap;
        margin-bottom: 12px;
    }

    .color-888 {
        color: #888;
    }

    .md-2018040201-lty .pic-box .bd-word .price {
        color: #fd573f;
        font-weight: bold;
    }

    .xuanze {
        display: inline-block;
        width: 74px;
        height: 23px;
        background-color: #49af4a;
        color: white;
        position: absolute;
        right: 5px;
        text-align: center;
        line-height: 23px;
        border-radius: 4px;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .pull-right {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/courseCenter.vue